export const ErrorMessage = {
    INVALID_PARAMETER: 'Invalid parameter `{0}`',
    POSITIVE_PARAMETER: 'Parameter `{0}` must > 0',
    POSITIVE_INCLUDE_ZERO_PARAMETER: 'Parameter `{0}` must >= 0',
    NULL_OR_EMPTY_PARAMETER: 'Parameter `{0}` null or empty',
    EMPTY_ARRAY_PARAMETER: 'Parameter `{0}` is empty array',
    FETCH_API_FAILED: 'Fetch api failed: {0}',
    NOT_FOUND_ITEMS: 'Not found any {0}',
};
